<div class="m-content">
	<div class="row">
		<div class="col-md-12">
			<!--begin::Portlet-->
			<div class="m-portlet m-portlet--tab">
				<div class="m-portlet__head">
					<div class="m-portlet__head-caption">
						<div class="m-portlet__head-title">
							<span class="m-portlet__head-icon m--hide">
								<i class="la la-gear"></i>
							</span>
							<h4 class="m-portlet__head-text">Change Single Point of Contact Details</h4>
							<p class="errMessage"> </p>
						</div>
					</div>
				</div>
				<div class="m-portlet__body">
					<form class="m-form m-form--fit m-form--label" [formGroup]="spocCreationForm">
						<div class="form-group m-form__group m--margin-top-10 form_header">
							SPOC Info:
						</div>
						<div class="form-group m-form__group row">
							<label for="tp-details" class="col-4 col-form-label tc-text-align">
								Full Name:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-8">
								<input class="form-control m-input" type="text" placeholder="Enter full name" formControlName="firstName">
								<app-form-control-messages [control]="spocCreationForm.controls.firstName" [name]="'Name of spoc'"></app-form-control-messages>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="tp-details" class="col-4 col-form-label tc-text-align">
								Email Address:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-8">
								<input class="form-control m-input" type="text" name="Spoc-email" placeholder="Enter the email address" formControlName="email">
								<app-form-control-messages [control]="spocCreationForm.controls.email" [name]="'Email of spoc'"></app-form-control-messages>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="tp-details" class="col-4 col-form-label tc-text-align">
								Mobile Number:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-8">

								<input class="form-control m-input" type="text" maxlength="10" name="mobile-number"  onkeypress="return event.charCode >= 48 && event.charCode <= 57"  placeholder="Enter mobile number" formControlName="mobileNumber">
								<app-form-control-messages [control]="spocCreationForm.controls.mobileNumber" [message]="'Mobile Number should be 10 digits'"
								    [name]="'Mobile of spoc'"></app-form-control-messages>
							</div>
						</div>
						<div class="m-portlet__foot m-portlet__foot--fit">
							<div class="m-form__actions">
								<div class="row">
									<div class="col-2"></div>
									<div class="col-10 text-center">
										<button type="button" data-toggle="modal" data-target="#spoc-popup" class="btn btn-next" (click)="saveSpoc()" [disabled]="!spocCreationForm.valid">
											Save & Next
										</button>
										<button type="button" class="btn btn-default marTop" (click)="back()">
											Cancel
										</button>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="spoc-popup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div *ngIf="!verifyCredDisplay">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">
						Verify Your Credentials
					</h5>
					<button type="button" class="close" aria-label="Close" #closeModel data-dismiss="modal">
						<span aria-hidden="true">
							&times;
						</span>
					</button>
				</div>
				<div class="modal-body">
					<form class="m-form m-form--fit m-form--label-align-right" [formGroup]="verifyCredentialsForm">
						<div class="m-portlet__body">
							<div class="form-group m-form__group row">
								<label for="tp-details" class="col-3 col-form-label">
									Enter your UserName:
									<span class="mandatoryColor">*</span>
								</label>
								<div class="col-9">
									<input class="form-control m-input" type="text" placeholder="Enter Your UserName" name="Request_ID" formControlName="userName">
									<app-form-control-messages [control]="verifyCredentialsForm.controls.userName" [name]="'UserName'"></app-form-control-messages>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label for="tp-details" class="col-3 col-form-label">
									Enter your Password:
									<span class="mandatoryColor">*</span>
								</label>
								<div class="col-9">
									<input class="form-control m-input" [type]="show ? 'text' : 'password'" formControlName="password" placeholder="Enter Password">
									<a class="showPassword" (click)="showPassClick()" aria-hidden="true">{{show ? 'Hide' : 'Show'}}</a>
									<app-form-control-messages [control]="verifyCredentialsForm.controls.password" [name]="'Password'"></app-form-control-messages>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-next verifybutton" [disabled]="!verifyCredentialsForm.valid" (click)="generateOtp()">
						Verify
					</button>
					<button type="button" class="btn  btn-cancel " data-dismiss="modal">
						Cancel
					</button>
				</div>
			</div>
			<div *ngIf="verifyCredDisplay">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">
						Verify OTP
					</h5>
					<button type="button" class="close" aria-label="Close" #closeModel data-dismiss="modal">
						<span aria-hidden="true">
							&times;
						</span>
					</button>
				</div>
				<div class="modal-body">
					<form class="m-form m-form--fit m-form--label-align-right" [formGroup]="verifyPasswordForm">
						<div class="form-group m-form__group row">
							<label for="tp-details" class="col-3 col-form-label">
								Enter Mobile One Time Password:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-9">
								<input class="form-control m-input" type="text" formControlName="mobileOTP" placeholder="Enter mobile one time password">
								<app-form-control-messages [control]="verifyPasswordForm.controls.mobileOTP" [name]="'Mobile One Time Password'"></app-form-control-messages>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="tp-details" class="col-3 col-form-label">
								Enter Email One Time Password:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-9">
								<input class="form-control m-input" type="text" formControlName="emailOTP" placeholder="Enter email one time password">
								<app-form-control-messages [control]="verifyPasswordForm.controls.emailOTP" [name]="'Email One Time Password'"></app-form-control-messages>
							</div>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-next verifybutton" (click)="verifyOTP()">
						Verify
					</button>
					<button type="button" class="btn  btn-cancel" data-dismiss="modal">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
